import type { TranscriptDeltaPayload } from './meetings.types';

export type RemoteTranscriptDeltaNormalizer = {
  normalize(delta: TranscriptDeltaPayload): TranscriptDeltaPayload;
  reset(): void;
};

export function createRemoteTranscriptDeltaNormalizer(): RemoteTranscriptDeltaNormalizer {
  const liveChunkIdsBySpeaker = new Map<string, number>();

  return {
    normalize(delta) {
      const liveChunkId =
        liveChunkIdsBySpeaker.get(delta.speaker) ?? delta.chunkId;
      const newlySupersededChunkIds = Array.from(
        liveChunkIdsBySpeaker.values()
      ).filter((chunkId) => chunkId !== liveChunkId);
      const supersededChunkIds =
        newlySupersededChunkIds.length === 0
          ? delta.supersededChunkIds
          : [...delta.supersededChunkIds, ...newlySupersededChunkIds];

      if (delta.isFinal) {
        liveChunkIdsBySpeaker.clear();
      } else {
        liveChunkIdsBySpeaker.clear();
        liveChunkIdsBySpeaker.set(delta.speaker, liveChunkId);
      }

      return {
        ...delta,
        chunkId: liveChunkId,
        supersededChunkIds,
      };
    },
    reset() {
      liveChunkIdsBySpeaker.clear();
    },
  };
}
